import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

export function CategoryTitle({ category }) {
  return (
    <Link to={`/discover/?category=${category}`} className="hover:underline">
      <span>c/{category}</span>
    </Link>
  );
}

CategoryTitle.propTypes = {
  category: PropTypes.string.isRequired,
};
